export const getActiveQuestionTypes = ({ mcqLength, frqLength }) => {
  // prettier-ignore
  const typesLength = [mcqLength > 0 && 'MCQ', frqLength > 0 && 'FRQ'].filter(val => val);
  // Add a line to the latest element
  typesLength[typesLength.length - 1] = `${typesLength.at(-1)} -`;
  return typesLength.join(' ');
};
